module.exports = __webpack_public_path__ + "img/front cover.d9866515.jpg";